import { styled } from "@mui/material";

export const BaseFieldSet = styled("fieldset")(() => {
    return {
        border: "none",
        marginInline: 0,
        paddingBlock: 0,
        paddingInline: 0,
        minInlineSize: 0,
    }
});
